import { Injectable, inject } from '@angular/core'
import { ApiService } from './api.service'
import { ApiResponse } from '../interfaces/api.interface'

/** The signed-in user's own photo (CC 05/10/2026: every role can set one). */
@Injectable({ providedIn: 'root' })
export class ProfilePhotoService {
  private readonly api = inject(ApiService)

  /** Uploads the cropped photo and returns its address. */
  async upload (photo: Blob): Promise<string> {
    const form = new FormData()
    form.append('photo', photo, 'avatar.jpg')
    const response = await this.api.post<ApiResponse<{ avatar: string }>>('/users/me/photo', form)
    return response.data.avatar
  }

  async remove (): Promise<void> {
    await this.api.delete<ApiResponse<{ avatar: string }>>('/users/me/photo')
  }
}
